import React from "react";
import "react-perfect-scrollbar/dist/css/styles.css";
import PerfectScrollbar from "react-perfect-scrollbar";
import Track from "../track/Track";
import { MDBTooltip } from "mdb-react-ui-kit";

const TracksList = ({
  selectOption,
  setSelectOption,
  stateTracks,
  loading,
  getTracks,
  getRacesTrack,
  getEntriesRace,
  openTracks,
  setOpenTracks,
}) => {
  return (
    <nav className="pcoded-navbar">
      <div className="navbar-wrapper">
        {!loading ? (
          <div className="navbar-content scroll-div">
            <PerfectScrollbar>
              <ul className="nav pcoded-inner-navbar">
                {stateTracks.length !== 0 &&
                  stateTracks.thoroughbredList.length !== 0 && (
                    <>
                      <li className="nav-item pcoded-menu-caption">
                        <label style={{ fontSize: "14px" }} className="mt-1">
                          <span className="pcoded-micon">
                            <img
                              className="thoroughbredIcon "
                              src="../images/ThoroughbredWhite.png"
                              alt=""
                            />
                          </span>{" "}
                          Thoroughbred
                        </label>
                        <button
                          type="button"
                          className="btn btn-icon btn-info"
                          style={{
                            borderRadius: "50%",
                            float: "right",
                          }}
                          onClick={() => {
                            getTracks();
                            setOpenTracks([]);
                          }}
                        >
                          <MDBTooltip
                            tag="i"
                            wrapperProps={{ href: "#" }}
                            title="Refresh"
                          >
                            <i className="feather icon-refresh-cw"></i>
                          </MDBTooltip>
                        </button>
                      </li>
                      {stateTracks.thoroughbredList.map((track, index) => {
                        let status = "open";
                        if (openTracks.includes(track.TrackID)) {
                          status = "close";
                        }
                        return (
                          <Track
                            key={index}
                            track={track} //solo los tracks de thoroughbred
                            setSelectOption={setSelectOption}
                            selectOption={selectOption}
                            stateTracks={stateTracks} //Todos los tracks
                            getRacesTrack={getRacesTrack}
                            getEntriesRace={getEntriesRace}
                            trackOption={stateTracks.trackList.find(
                              (item) => item.TrackID === track.TrackID
                            )}
                            openTracks={openTracks}
                            status={status}
                          />
                        );
                      })}
                    </>
                  )}

                {stateTracks.length !== 0 &&
                  stateTracks.harnessList.length !== 0 && (
                    <>
                      <li className="nav-item pcoded-menu-caption">
                        <label style={{ fontSize: "14px" }}>
                          <span className="pcoded-micon">
                            <img
                              className="thoroughbredIcon"
                              src="../images/HarnessWhite.png"
                              alt=""
                            />
                          </span>{" "}
                          Harness
                        </label>
                      </li>
                      {stateTracks.harnessList.map((track, index) => {
                        let status = "open";
                        if (openTracks.includes(track.TrackID)) {
                          status = "close";
                        }
                        return (
                          <Track
                            key={index}
                            track={track} //solo los tracks de thoroughbred
                            setSelectOption={setSelectOption}
                            selectOption={selectOption}
                            stateTracks={stateTracks} //Todos los tracks
                            getRacesTrack={getRacesTrack}
                            getEntriesRace={getEntriesRace}
                            trackOption={stateTracks.trackList.find(
                              (item) => item.TrackID === track.TrackID
                            )}
                            openTracks={openTracks}
                            status={status}
                          />
                        );
                      })}
                    </>
                  )}

                {stateTracks.length !== 0 &&
                  stateTracks.greyList.length !== 0 && (
                    <>
                      <li className="nav-item pcoded-menu-caption">
                        <label style={{ fontSize: "14px" }}>
                          <span className="pcoded-micon">
                            <img
                              className="thoroughbredIcon"
                              src="../images/GreyhoundsWhite.png"
                              alt=""
                            />
                          </span>{" "}
                          Greyhounds
                        </label>
                      </li>
                      {stateTracks.greyList.map((track, index) => {
                        let status = "open";
                        if (openTracks.includes(track.TrackID)) {
                          status = "close";
                        }
                        return (
                          <Track
                            key={index}
                            track={track} //solo los tracks de thoroughbred
                            setSelectOption={setSelectOption}
                            selectOption={selectOption}
                            stateTracks={stateTracks} //Todos los tracks
                            getRacesTrack={getRacesTrack}
                            getEntriesRace={getEntriesRace}
                            trackOption={stateTracks.trackList.find(
                              (item) => item.TrackID === track.TrackID
                            )}
                            openTracks={openTracks}
                            status={status}
                          />
                        );
                      })}
                    </>
                  )}
              </ul>
            </PerfectScrollbar>
          </div>
        ) : (
          <div
            className="navbar-content scroll-div"
            style={{
              textAlign: "center",
              verticalAlign: "middle",
              height: "calc(91vh - 78px)",
            }}
          >
            <span
              className="spinner-border spinner-border-sm mr-2"
              role="status"
              aria-hidden="true"
            ></span>
            <span>Loading...</span>
          </div>
        )}
      </div>
    </nav>
  );
};

export default TracksList;
